jQuery(document).ready(function () {
            // Find all elements with class step-title
  setTimeout(function() {
            jQuery('.step-title').each(function () {
                // Get all siblings following this step-title until the next step-title
                var stepElements = jQuery(this).nextUntil('.step-title').addBack();
                // Wrap the found elements in a div with class main-step
                stepElements.wrapAll('<div class="main-step"></div>');
            });
    }, 1000);

  jQuery('.collection-img-slider').slick({
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      arrows:true,
      autoplay: true,
      autoplaySpeed: 3000,
    
  });
  
    jQuery('.collection-img-slider-v2').slick({
      dots: true,
      infinite: true,
      speed: 600,
      slidesToShow: 1,
      arrows:true,
      autoplay: true,
      autoplaySpeed: 3000,
    
  });
  
  function why_tuner_checkScreenWidth() {
    if (window.innerWidth < 768) {
      jQuery('.shopify-section .why-tuner-image-block .multi-column').slick({
          dots: true,
          infinite: true,
          speed: 600,
          slidesToShow: 1,
          arrows:true,
          autoplay: true,
          autoplaySpeed: 3000,
        
      });
    }
  }
  
  why_tuner_checkScreenWidth();  
  
  window.addEventListener('resize', function() {
    why_tuner_checkScreenWidth();
  });

  function other_collections_checkScreenWidth() {
    if (window.innerWidth < 768) {
      jQuery('.other-collections .collection-list').slick({
          dots: false,
          infinite: true,
          speed: 600,
          slidesToShow: 1,
          arrows:false,
          autoplay: false,
          autoplaySpeed: 3000,
        
      });
    }
  }
  
  other_collections_checkScreenWidth();  
  
  window.addEventListener('resize', function() {
    other_collections_checkScreenWidth();
  });
  
  // Equal Height
  equalheight = function(container){
  
  var currentTallest = 0,
     currentRowStart = 0,
     rowDivs = new Array(),
     $el,
     topPosition = 0;
  jQuery(container).each(function() {
  
   $el = jQuery(this);
   jQuery($el).height('auto')
   topPostion = $el.position().top;
  
   if (currentRowStart != topPostion) {
     for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
       rowDivs[currentDiv].height(currentTallest);
     }
     rowDivs.length = 0; // empty the array
     currentRowStart = topPostion;
     currentTallest = $el.height();
     rowDivs.push($el);
   } else {
     rowDivs.push($el);
     currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
  }
   for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
     rowDivs[currentDiv].height(currentTallest);
   }
  });
  }
  
  jQuery(window).load(function() {
  equalheight('.shopify-section .why-tuner-image-block .multi-column .multi-column__item');
  });
  
  
  jQuery(window).resize(function(){
  equalheight('.shopify-section .why-tuner-image-block .multi-column .multi-column__item');
  });


  // Hide all accordions after the more-faq element
  jQuery('.more-faqs').nextAll('.accordion').hide();

  // Show the hidden accordions when more-faq is clicked
  jQuery('.more-faqs').click(function() {
     jQuery(this).hide();
    jQuery(this).nextAll('.accordion').slideToggle(200);
  });
  setTimeout(function() {
      jQuery('.angle-of-vehicle .ymq-options-img-label').each(function(){
          jQuery(this).find('.ymq_tooltip_show').removeAttr('style');
      });
   }, 1000);

   setTimeout(function() {
      jQuery('.choose-bg .ymq-options-img-label').each(function(){
          jQuery(this).find('.ymq_tooltip_show').removeAttr('style');
      });
   }, 1000);
 
});

jQuery(document).ready(function() {
  jQuery("div[id^='shopify-block-loox_reviews_loox_dynamic_section_']").parents('.shopify-section').addClass('single-product-review-section');
    function moveDivIfNeeded() {
        if (jQuery(window).width() >= 768) {
             var dynamicDiv = jQuery("div[id^='shopify-block-loox_reviews_loox_snippets_widget_']");
             jQuery(dynamicDiv).wrap( "<div class='shopify-reviews-snippets'></div>" );
             jQuery('.shopify-reviews-snippets').appendTo(".product .product-gallery");
        }
    }
    moveDivIfNeeded();
    jQuery(window).resize(function() {
        moveDivIfNeeded();
    });
   function number_format (number, decimals, dec_point, thousands_sep){
	    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
	    var n = !isFinite(+number) ? 0 : +number,
	        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
	        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
	        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
	        s = '',
	        toFixedFix = function (n, prec) {
	            var k = Math.pow(10, prec);
	            return '' + Math.round(n * k) / k;
	        };
	    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	    if (s[0].length > 3) {
	        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	    }
	    if ((s[1] || '').length < prec) {
	        s[1] = s[1] || '';
	        s[1] += new Array(prec - s[1].length + 1).join('0');
	    }
	    return s.join(dec);
	} 
    jQuery('.payment-terms .shopify-product-form').on('keyup change paste', 'input, select, textarea', function(){
      setTimeout(function(){
          var productPrice = jQuery('.buy-buttons .total-prc .price').attr('data-price');
          productPrice = parseFloat(productPrice.replace(/[^0-9.-]/g, ''));
          if(jQuery('#ymq-addons-price .ymq-price-span').length > 0){
              var addonPrice = jQuery('#ymq-addons-price .ymq-price-span').attr('data-ymq-original-money');   
              addonPrice = parseFloat(addonPrice.replace(/[^0-9.-]/g, ''));
          }else{
              var addonPrice = 0;
          }
          var result = addonPrice + productPrice;
          jQuery('.buy-buttons .total-prc .price').text(number_format(result,2,'.',','));
      },100)
    });
      
    
});



      
